module.exports = __webpack_public_path__ + "img/ny.56e79cd0.jpg";